import imageCompression from 'browser-image-compression';
import React, { useState, useRef } from 'react';
import logo from '../logo_blade.png';
import { auth, db, storage } from '../services/firebase';
import { createUserWithEmailAndPassword, sendEmailVerification } from 'firebase/auth';
import { doc, setDoc, updateDoc } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import TermosModal from '../components/TermosModal';
import emailjs from '@emailjs/browser';

const duracoes = ['15 min','30 min','45 min','60 min','75 min','90 min','120 min'];

const PAISES = [
  { nome: 'Brasil',       bandeira: '🇧🇷', codigo: '+55',  digitos: 11, mascara: '(##) #####-####' },
  { nome: 'Portugal',     bandeira: '🇵🇹', codigo: '+351', digitos: 9,  mascara: '### ### ###' },
  { nome: 'EUA / Canadá', bandeira: '🇺🇸', codigo: '+1',   digitos: 10, mascara: '(###) ###-####' },
  { nome: 'Argentina',    bandeira: '🇦🇷', codigo: '+54',  digitos: 10, mascara: '## ####-####' },
  { nome: 'Uruguai',      bandeira: '🇺🇾', codigo: '+598', digitos: 8,  mascara: '#### ####' },
  { nome: 'Chile',        bandeira: '🇨🇱', codigo: '+56',  digitos: 9,  mascara: '# #### ####' },
];

function aplicarMascara(valor, mascara) {
  let i = 0;
  return mascara.replace(/#/g, () => valor[i++] || '');
}

async function uploadFoto(arquivo, caminho) {
  if (!arquivo) return '';
  const options = { maxSizeMB: 0.5, maxWidthOrHeight: 800, useWebWorker: true };
  const arquivoComprimido = await imageCompression(arquivo, options);
  const storageRef = ref(storage, caminho);
  await uploadBytes(storageRef, arquivoComprimido);
  return await getDownloadURL(storageRef);
}

// ── Componente de foto estilo avatar profissional ──
function FotoUpload({ fotoArquivo, fotoUrl, onArquivo, circular = true, size = 96 }) {
  const inputRef = useRef(null);
  const preview = fotoArquivo ? URL.createObjectURL(fotoArquivo) : (fotoUrl || null);
  const radius = circular ? '50%' : '18px';

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '20px' }}>
      <div
        onClick={() => inputRef.current?.click()}
        style={{
          width: size, height: size,
          borderRadius: radius,
          backgroundColor: '#1c1c1c',
          border: preview ? '2.5px solid #2d4a2d' : '1.5px dashed #2a2a2a',
          overflow: 'hidden',
          cursor: 'pointer',
          position: 'relative',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          flexShrink: 0,
          transition: 'border-color 0.2s',
        }}
      >
        {preview ? (
          <img src={preview} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        ) : circular ? (
          /* Silhueta de pessoa */
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
            <circle cx="24" cy="18" r="10" fill="#252525"/>
            <path d="M4 46C4 33 11 28 24 28C37 28 44 33 44 46" fill="#252525"/>
          </svg>
        ) : (
          /* Ícone de estabelecimento */
          <svg width="52" height="52" viewBox="0 0 52 52" fill="none">
            <rect x="8" y="24" width="36" height="22" rx="2.5" fill="#252525"/>
            <path d="M4 26L26 10L48 26" stroke="#2a2a2a" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
            <rect x="20" y="32" width="12" height="14" rx="2" fill="#2f2f2f"/>
          </svg>
        )}

        {/* Badge câmera */}
        <div style={{
          position: 'absolute',
          bottom: circular ? 3 : 6,
          right: circular ? 3 : 6,
          width: 30, height: 30,
          backgroundColor: '#2d4a2d',
          borderRadius: '50%',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          border: '2.5px solid #111111',
          boxShadow: '0 2px 6px rgba(0,0,0,0.5)',
        }}>
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
            <path d="M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2z"
              stroke="#7bc47b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <circle cx="12" cy="13" r="4" stroke="#7bc47b" strokeWidth="2"/>
          </svg>
        </div>
      </div>

      <span style={{ fontSize: '11px', color: '#8f8f8f', marginTop: '8px' }}>
        {preview ? 'Toque para alterar a foto' : 'Toque para adicionar foto'}
      </span>

      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        style={{ display: 'none' }}
        onChange={e => e.target.files[0] && onArquivo(e.target.files[0])}
      />
    </div>
  );
}

function CadastroBarbearia({ onCadastrar, onVoltar, onInicio }) {
  const [etapa, setEtapa] = useState(1);

  // Etapa 1 — Dados
  const [nome, setNome] = useState('');
  const [fotoBarbeariaArquivo, setFotoBarbeariaArquivo] = useState(null);
  const [rua, setRua] = useState('');
  const [numero, setNumero] = useState('');
  const [complemento, setComplemento] = useState('');
  const [bairro, setBairro] = useState('');
  const [cidade, setCidade] = useState('');
  const [estado, setEstado] = useState('');
  const [cep, setCep] = useState('');
  const [cepCarregando, setCepCarregando] = useState(false);

  // Telefone com DDI
  const [telefonePais, setTelefonePais] = useState(PAISES[0]);
  const [telefoneDigitos, setTelefoneDigitos] = useState('');
  const [mostrarPaises, setMostrarPaises] = useState(false);

  // Etapa 2 — Barbeiros
  const [barbeiros, setBarbeiros] = useState([{ nome: '', fotoArquivo: null }]);

  // Etapa 3 — Serviços
  const [servicos, setServicos] = useState([{ nome: '', preco: '', duracao: '30 min' }]);

  // Etapa 4 — Acesso
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [confirmar, setConfirmar] = useState('');
  const [mostrarSenha, setMostrarSenha] = useState(false);
  const [termosAceitos, setTermosAceitos] = useState(false);
  const [mostrarTermos, setMostrarTermos] = useState(false);

  const [erro, setErro] = useState('');
  const [carregando, setCarregando] = useState(false);
  const [cadastroConcluido, setCadastroConcluido] = useState(null); // { emailOk, dados }

  // ── CEP: busca automática via ViaCEP ──
  async function buscarCep(valor) {
    // formata e atualiza o campo
    const digits = valor.replace(/\D/g, '').slice(0, 8);
    const formatado = digits.length > 5
      ? digits.slice(0, 5) + '-' + digits.slice(5)
      : digits;
    setCep(formatado);

    if (digits.length !== 8) return;
    setCepCarregando(true);
    try {
      const resp = await fetch(`https://viacep.com.br/ws/${digits}/json/`);
      const data = await resp.json();
      if (!data.erro) {
        setRua(data.logradouro || '');
        setBairro(data.bairro || '');
        setCidade(data.localidade || '');
        setEstado(data.uf || '');
      }
    } catch (e) {
      console.error('Erro CEP:', e);
    }
    setCepCarregando(false);
  }

  // ── Preço em R$ formatado ──
  function handlePrecoChange(i, raw) {
    // Remove tudo exceto dígitos e vírgula
    let v = raw.replace(/[^0-9,]/g, '');
    // Garante no máximo uma vírgula
    const parts = v.split(',');
    if (parts.length > 2) v = parts[0] + ',' + parts.slice(1).join('');
    // Limita a 2 casas decimais
    if (parts[1] !== undefined) v = parts[0] + ',' + parts[1].slice(0, 2);
    // Remove zeros à esquerda (exceto "0,")
    if (v && !v.startsWith('0,')) v = v.replace(/^0+/, '') || '';
    updateServico(i, 'preco', v ? `R$ ${v}` : '');
  }

  // ── Telefone ──
  const telefoneMascarado = aplicarMascara(telefoneDigitos, telefonePais.mascara);
  const telefoneCompleto = telefonePais.codigo + telefoneDigitos;

  // ── Barbeiros ──
  function addBarbeiro() {
    if (barbeiros.length < 10) setBarbeiros([...barbeiros, { nome: '', fotoArquivo: null }]);
  }
  function updateBarbeiro(index, field, value) {
    const novos = [...barbeiros]; novos[index][field] = value; setBarbeiros(novos);
  }
  function removeBarbeiro(index) {
    if (barbeiros.length > 1) setBarbeiros(barbeiros.filter((_, i) => i !== index));
  }

  // ── Serviços ──
  function addServico() {
    if (servicos.length < 15) setServicos([...servicos, { nome: '', preco: '', duracao: '30 min' }]);
  }
  function updateServico(index, field, value) {
    const novos = [...servicos]; novos[index][field] = value; setServicos(novos);
  }
  function removeServico(index) {
    if (servicos.length > 1) setServicos(servicos.filter((_, i) => i !== index));
  }

  // ── Validações ──
  function validar1() {
    if (!nome.trim() || !rua.trim() || !numero.trim() || !bairro.trim() || !cidade.trim() || !estado.trim() || !cep.trim()) {
      setErro('Preencha todos os campos obrigatórios'); return false;
    }
    if (telefoneDigitos.length !== telefonePais.digitos) {
      setErro(`Digite um número de telefone válido (${telefonePais.digitos} dígitos)`); return false;
    }
    setErro(''); return true;
  }
  function validar2() {
    if (barbeiros.filter(b => b.nome.trim()).length === 0) {
      setErro('Adicione pelo menos um barbeiro'); return false;
    }
    setErro(''); return true;
  }
  function validar3() {
    if (servicos.filter(s => s.nome.trim() && s.preco.trim()).length === 0) {
      setErro('Adicione pelo menos um serviço com nome e preço'); return false;
    }
    setErro(''); return true;
  }

  // ── Geocodificação via Nominatim (silenciosa — não bloqueia o cadastro) ──
  async function geocodificar(enderecoStr) {
    try {
      const url = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(enderecoStr)}&limit=1`;
      const resp = await fetch(url, { headers: { 'Accept-Language': 'pt-BR', 'User-Agent': 'BladeApp/1.0' } });
      const data = await resp.json();
      if (data.length > 0) return { lat: parseFloat(data[0].lat), lng: parseFloat(data[0].lon) };
    } catch (_) {}
    return null;
  }

  // ── Cadastro final ──
  async function handleCadastro() {
    if (!email || !senha || !confirmar) { setErro('Preencha todos os campos'); return; }
    if (senha !== confirmar) { setErro('As senhas não coincidem'); return; }
    if (senha.length < 6) { setErro('A senha deve ter pelo menos 6 caracteres'); return; }
    if (!termosAceitos) { setErro('Você precisa aceitar os Termos de Uso para continuar'); return; }

    setCarregando(true);
    try {
      const resultado = await createUserWithEmailAndPassword(auth, email, senha);
      const uid = resultado.user.uid;

      // Verificação de e-mail da barbearia (espelha o cliente): prova que o e-mail é real
      // antes do login. O link de aprovação do admin segue separado.
      await sendEmailVerification(resultado.user);

      const fotoBarb = await uploadFoto(fotoBarbeariaArquivo, `barbearias/${uid}/foto_barbearia`);

      const barbeirosComFoto = await Promise.all(
        barbeiros.filter(b => b.nome.trim()).map(async (b, i) => {
          const fotoUrl = await uploadFoto(b.fotoArquivo, `barbearias/${uid}/barbeiro_${i}`);
          return { nome: b.nome, foto: fotoUrl };
        })
      );

      const enderecoCompleto = `${rua}, ${numero}${complemento ? ` ${complemento}` : ''} — ${bairro}, ${cidade} - ${estado}, CEP ${cep}`;

      const coords = await geocodificar(`${rua}, ${numero}, ${bairro}, ${cidade}, ${estado}, Brasil`);

      await setDoc(doc(db, 'barbearias', uid), {
        nome,
        foto: fotoBarb,
        endereco: { rua, numero, complemento, bairro, cidade, estado, cep, completo: enderecoCompleto },
        telefone: telefoneCompleto,
        barbeiros: barbeirosComFoto,
        servicos: servicos.filter(s => s.nome.trim() && s.preco.trim()),
        email,
        status: 'pendente',
        cadastroCompleto: true,
        termosAceitos: true,
        termosAceitosEm: new Date().toISOString(),
        criadoEm: new Date().toISOString(),
        ...(coords ? { lat: coords.lat, lng: coords.lng } : {}),
      });

      // E-mail de aprovação
      const serviceId  = process.env.REACT_APP_EMAILJS_SERVICE_ID  || '';
      const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID || '';
      const publicKey  = process.env.REACT_APP_EMAILJS_PUBLIC_KEY  || '';

      let emailOk = false;
      let emailErroDetalhe = '';

      try {
        await emailjs.send(serviceId, templateId, {
          nome_responsavel: nome,
          nome_barbearia:   nome,
          telefone:         telefoneCompleto,
          endereco:         enderecoCompleto,
          link_aprovacao:   `https://blade.app.br/admin/aprovar?id=${uid}`,
          to_email:         'blade.app.conta@gmail.com',
        }, publicKey);
        emailOk = true;
        await updateDoc(doc(db, 'barbearias', uid), { emailAprovacaoEnviado: true });
      } catch (emailErr) {
        console.error('Erro ao enviar e-mail de aprovação:', emailErr);
        try {
          emailErroDetalhe = typeof emailErr === 'string'
            ? emailErr
            : (emailErr?.text || emailErr?.message || JSON.stringify(emailErr) || 'sem detalhe');
        } catch (_) {
          emailErroDetalhe = 'erro ao capturar detalhe';
        }
      }

      // Desloga para forçar verificação de e-mail + aprovação antes de entrar no painel
      await auth.signOut();

      // Mostra tela de confirmação com status do email
      setCadastroConcluido({ emailOk, emailErroDetalhe, dados: { nome, email, uid } });
    } catch (e) {
      console.error('ERRO CADASTRO:', e.code, e.message);
      if (e.code === 'auth/email-already-in-use') setErro('Este email já está cadastrado');
      else setErro(`Erro ao cadastrar: ${e.message}`);
    }
    setCarregando(false);
  }

  const inputStyle = {
    width: '100%', padding: '12px', borderRadius: '10px',
    border: '0.5px solid #2a2a2a', backgroundColor: '#1a1a1a',
    color: '#e8e8e8', fontSize: '14px', boxSizing: 'border-box',
    outline: 'none', fontFamily: 'Arial, sans-serif',
  };
  const labelStyle = {
    fontSize: '10px', color: '#9c9c9c', letterSpacing: '1px',
    textTransform: 'uppercase', display: 'block', marginBottom: '5px',
  };
  const stepBtn = (n) => ({
    width: '28px', height: '28px', borderRadius: '50%',
    backgroundColor: etapa >= n ? '#2d4a2d' : '#1a1a1a',
    border: `1px solid ${etapa >= n ? '#3d6b3d' : '#2a2a2a'}`,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: '11px', fontWeight: '600',
    color: etapa >= n ? '#7bc47b' : '#444',
  });

  // ── Tela de confirmação pós-cadastro ──
  if (cadastroConcluido) {
    const { emailOk, emailErroDetalhe, dados } = cadastroConcluido;
    return (
      <div style={{
        backgroundColor: '#111111', minHeight: '100vh',
        display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center',
        fontFamily: 'Arial, sans-serif', padding: '40px 24px', textAlign: 'center'
      }}>
        <img src={logo} alt="BLADE" style={{ width: '90px', marginBottom: '32px' }} onClick={onInicio} />

        {/* Ícone */}
        <div style={{
          width: '72px', height: '72px', borderRadius: '50%',
          backgroundColor: '#1a2a1a', border: '2px solid #2d4a2d',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          marginBottom: '20px'
        }}>
          <span style={{ fontSize: '30px' }}>✂️</span>
        </div>

        <h2 style={{ fontSize: '22px', fontWeight: '700', color: '#e8e8e8', margin: '0 0 8px' }}>
          Cadastro enviado!
        </h2>
        <p style={{ fontSize: '13px', color: '#8f8f8f', margin: '0 0 20px', lineHeight: '1.7', maxWidth: '300px' }}>
          Sua barbearia foi registrada e está aguardando aprovação da equipe BLADE.
        </p>

        {/* Verificação de e-mail da barbearia */}
        <div style={{
          width: '100%', maxWidth: '320px',
          backgroundColor: '#0a1620', border: '0.5px solid #1a3a5a',
          borderRadius: '12px', padding: '14px 16px', marginBottom: '16px',
          display: 'flex', alignItems: 'flex-start', gap: '12px', textAlign: 'left'
        }}>
          <span style={{ fontSize: '18px', flexShrink: 0 }}>📨</span>
          <div>
            <p style={{ fontSize: '13px', fontWeight: '600', color: '#378ADD', margin: '0 0 3px' }}>
              Confirme seu e-mail
            </p>
            <p style={{ fontSize: '11px', color: '#8f8f8f', margin: 0, lineHeight: '1.5' }}>
              Enviamos um link de verificação para <span style={{ color: '#7bc47b' }}>{dados.email}</span>. Clique nele antes de fazer login.
            </p>
          </div>
        </div>

        {/* Status do email */}
        <div style={{
          width: '100%', maxWidth: '320px',
          backgroundColor: emailOk ? '#1a2a1a' : '#1a1209',
          border: `0.5px solid ${emailOk ? '#2d4a2d' : '#4a3a1a'}`,
          borderRadius: '12px', padding: '14px 16px', marginBottom: '28px',
          display: 'flex', alignItems: 'flex-start', gap: '12px', textAlign: 'left'
        }}>
          <span style={{ fontSize: '18px', flexShrink: 0 }}>{emailOk ? '✅' : '⚠️'}</span>
          <div>
            <p style={{ fontSize: '13px', fontWeight: '600', color: emailOk ? '#7bc47b' : '#c9a84c', margin: '0 0 3px' }}>
              {emailOk ? 'Email de aprovação enviado' : 'Email não pôde ser enviado'}
            </p>
            <p style={{ fontSize: '11px', color: '#8f8f8f', margin: 0, lineHeight: '1.5' }}>
              {emailOk
                ? 'A equipe BLADE foi notificada e vai analisar em até 24h.'
                : 'Isso não afeta seu cadastro. Entre em contato com blade.app.conta@gmail.com se precisar de suporte.'
              }
            </p>
            {!emailOk && emailErroDetalhe ? (
              <p style={{ fontSize: '10px', color: '#aeaeae', margin: '8px 0 0', fontFamily: 'monospace', wordBreak: 'break-all', lineHeight: '1.4' }}>
                Detalhe: {emailErroDetalhe}
              </p>
            ) : null}
          </div>
        </div>

        <button
          onClick={() => onCadastrar(dados)}
          style={{
            width: '100%', maxWidth: '320px',
            backgroundColor: '#2d4a2d', color: '#7bc47b',
            border: 'none', borderRadius: '12px', padding: '15px',
            fontSize: '14px', fontWeight: '600', cursor: 'pointer',
            fontFamily: 'Arial, sans-serif', marginBottom: '10px'
          }}
        >
          Ir para o login
        </button>

        <button
          onClick={onInicio}
          style={{
            width: '100%', maxWidth: '320px',
            backgroundColor: 'transparent', color: '#7d7d7d',
            border: '0.5px solid #252525', borderRadius: '12px', padding: '13px',
            fontSize: '13px', cursor: 'pointer', fontFamily: 'Arial, sans-serif'
          }}
        >
          Voltar ao início
        </button>
      </div>
    );
  }

  return (
    <div style={{ backgroundColor: '#111111', minHeight: '100vh', fontFamily: 'Arial, sans-serif', color: '#e8e8e8', padding: '40px 24px 60px' }}>

      {mostrarTermos && <TermosModal tipo="barbearia" onFechar={() => setMostrarTermos(false)} />}

      <div style={{ textAlign: 'center', marginBottom: '20px' }}>
        <img src={logo} alt="BLADE" style={{ width: '100px', cursor: 'pointer' }} onClick={onInicio} />
      </div>

      {/* Indicador de etapas */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px', marginBottom: '28px' }}>
        {[1,2,3,4].map(n => (
          <React.Fragment key={n}>
            <div style={stepBtn(n)}>{n}</div>
            {n < 4 && <div style={{ width: '28px', height: '1px', backgroundColor: etapa > n ? '#2d4a2d' : '#2a2a2a' }} />}
          </React.Fragment>
        ))}
      </div>

      {/* ═══════════════ ETAPA 1 ═══════════════ */}
      {etapa === 1 && (
        <>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '24px' }}>
            <span onClick={onVoltar} style={{ fontSize: '22px', color: '#8f8f8f', cursor: 'pointer' }}>‹</span>
            <h2 style={{ fontSize: '18px', fontWeight: '700', margin: 0 }}>Dados da barbearia</h2>
          </div>

          {/* Foto da barbearia — estilo storefront */}
          <FotoUpload
            fotoArquivo={fotoBarbeariaArquivo}
            onArquivo={setFotoBarbeariaArquivo}
            circular={false}
            size={104}
          />

          <div style={{ marginBottom: '12px' }}>
            <label style={labelStyle}>Nome da barbearia *</label>
            <input type="text" placeholder="Ex: Barbearia do João" value={nome}
              onChange={e => setNome(e.target.value)} style={inputStyle} />
          </div>

          {/* Telefone com DDI/DDD */}
          <div style={{ marginBottom: '12px' }}>
            <label style={labelStyle}>Telefone / WhatsApp *</label>
            <div style={{ display: 'flex', gap: '8px' }}>

              {/* Seletor DDI */}
              <div style={{ position: 'relative', flexShrink: 0 }}>
                <button
                  type="button"
                  onClick={() => setMostrarPaises(!mostrarPaises)}
                  style={{
                    height: '46px', padding: '0 12px',
                    backgroundColor: '#1a1a1a', border: '0.5px solid #2a2a2a',
                    borderRadius: '10px', color: '#e8e8e8', cursor: 'pointer',
                    fontSize: '14px', display: 'flex', alignItems: 'center', gap: '6px',
                    whiteSpace: 'nowrap', fontFamily: 'Arial, sans-serif',
                  }}
                >
                  <span>{telefonePais.bandeira}</span>
                  <span>{telefonePais.codigo}</span>
                  <span style={{ fontSize: '9px', color: '#8f8f8f' }}>▼</span>
                </button>

                {mostrarPaises && (
                  <div style={{
                    position: 'absolute', top: 'calc(100% + 4px)', left: 0, zIndex: 200,
                    backgroundColor: '#1a1a1a', border: '0.5px solid #2a2a2a',
                    borderRadius: '10px', overflow: 'hidden', minWidth: '200px',
                    boxShadow: '0 8px 24px rgba(0,0,0,0.6)',
                  }}>
                    {PAISES.map(p => (
                      <div
                        key={p.codigo}
                        onClick={() => { setTelefonePais(p); setTelefoneDigitos(''); setMostrarPaises(false); }}
                        style={{
                          padding: '11px 14px', cursor: 'pointer', fontSize: '13px',
                          color: telefonePais.codigo === p.codigo ? '#7bc47b' : '#ccc',
                          backgroundColor: telefonePais.codigo === p.codigo ? '#1e2e1e' : 'transparent',
                          display: 'flex', alignItems: 'center', gap: '10px',
                        }}
                      >
                        <span>{p.bandeira}</span>
                        <span style={{ flex: 1 }}>{p.nome}</span>
                        <span style={{ color: '#8f8f8f', fontSize: '12px' }}>{p.codigo}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              {/* Input do número */}
              <input
                type="tel"
                inputMode="numeric"
                placeholder={telefonePais.mascara.replace(/#/g, '0')}
                value={telefoneMascarado}
                onChange={e => {
                  const raw = e.target.value.replace(/\D/g, '').slice(0, telefonePais.digitos);
                  setTelefoneDigitos(raw);
                }}
                style={{ ...inputStyle, flex: 1 }}
              />
            </div>
          </div>

          {/* CEP — primeiro para preencher o restante automaticamente */}
          <div style={{ marginBottom: '12px' }}>
            <label style={labelStyle}>CEP *</label>
            <div style={{ position: 'relative' }}>
              <input
                type="text"
                inputMode="numeric"
                placeholder="00000-000"
                value={cep}
                onChange={e => buscarCep(e.target.value)}
                maxLength={9}
                style={inputStyle}
              />
              {cepCarregando && (
                <span style={{
                  position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)',
                  fontSize: '11px', color: '#7bc47b',
                }}>buscando...</span>
              )}
            </div>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 80px', gap: '8px', marginBottom: '12px' }}>
            <div>
              <label style={labelStyle}>Rua / Avenida *</label>
              <input type="text" placeholder="Nome da rua" value={rua}
                onChange={e => setRua(e.target.value)} style={inputStyle} />
            </div>
            <div>
              <label style={labelStyle}>Número *</label>
              <input type="text" placeholder="Nº" value={numero}
                onChange={e => setNumero(e.target.value)} style={inputStyle} />
            </div>
          </div>

          <div style={{ marginBottom: '12px' }}>
            <label style={labelStyle}>Complemento</label>
            <input type="text" placeholder="Sala, andar, loja..." value={complemento}
              onChange={e => setComplemento(e.target.value)} style={inputStyle} />
          </div>

          <div style={{ marginBottom: '12px' }}>
            <label style={labelStyle}>Bairro *</label>
            <input type="text" placeholder="Nome do bairro" value={bairro}
              onChange={e => setBairro(e.target.value)} style={inputStyle} />
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 70px', gap: '8px', marginBottom: '16px' }}>
            <div>
              <label style={labelStyle}>Cidade *</label>
              <input type="text" placeholder="Sua cidade" value={cidade}
                onChange={e => setCidade(e.target.value)} style={inputStyle} />
            </div>
            <div>
              <label style={labelStyle}>UF *</label>
              <input type="text" placeholder="SP" maxLength={2} value={estado}
                onChange={e => setEstado(e.target.value.toUpperCase())} style={inputStyle} />
            </div>
          </div>

          {/* Preview do endereço */}
          {rua && numero && bairro && cidade && (
            <div style={{
              backgroundColor: '#1a2a1a', border: '0.5px solid #2d4a2d',
              borderRadius: '10px', padding: '12px', marginBottom: '16px',
            }}>
              <div style={{ fontSize: '10px', color: '#7bc47b', marginBottom: '4px', letterSpacing: '1px', textTransform: 'uppercase' }}>
                Como vai aparecer
              </div>
              <div style={{ fontSize: '12px', color: '#ccc', lineHeight: '1.6' }}>
                {rua}, {numero}{complemento ? ` ${complemento}` : ''} — {bairro}<br/>
                {cidade} - {estado}{cep ? `, CEP ${cep}` : ''}
              </div>
            </div>
          )}

          {erro && <p style={{ fontSize: '12px', color: '#e24b4a', marginBottom: '8px' }}>{erro}</p>}
          <button onClick={() => { if (validar1()) setEtapa(2); }} style={{
            width: '100%', backgroundColor: '#2d4a2d', color: '#7bc47b',
            border: 'none', borderRadius: '12px', padding: '14px',
            fontSize: '14px', fontWeight: '600', cursor: 'pointer', fontFamily: 'Arial, sans-serif',
          }}>Continuar</button>
        </>
      )}

      {/* ═══════════════ ETAPA 2 ═══════════════ */}
      {etapa === 2 && (
        <>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '24px' }}>
            <span onClick={() => setEtapa(1)} style={{ fontSize: '22px', color: '#8f8f8f', cursor: 'pointer' }}>‹</span>
            <h2 style={{ fontSize: '18px', fontWeight: '700', margin: 0 }}>Equipe de barbeiros</h2>
          </div>

          {barbeiros.map((b, i) => (
            <div key={i} style={{
              backgroundColor: '#181818', border: '0.5px solid #252525',
              borderRadius: '14px', padding: '20px 16px 16px', marginBottom: '12px',
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                <span style={{ fontSize: '12px', color: '#7bc47b', fontWeight: '600' }}>Barbeiro {i + 1}</span>
                {barbeiros.length > 1 && (
                  <span onClick={() => removeBarbeiro(i)} style={{ fontSize: '20px', color: '#e24b4a', cursor: 'pointer', lineHeight: 1 }}>×</span>
                )}
              </div>

              {/* Avatar circular */}
              <FotoUpload
                fotoArquivo={b.fotoArquivo}
                onArquivo={arquivo => updateBarbeiro(i, 'fotoArquivo', arquivo)}
                circular={true}
                size={88}
              />

              <div>
                <label style={labelStyle}>Nome do barbeiro</label>
                <input type="text" placeholder="Nome completo" value={b.nome}
                  onChange={e => updateBarbeiro(i, 'nome', e.target.value)} style={inputStyle} />
              </div>
            </div>
          ))}

          {barbeiros.length < 10 && (
            <button onClick={addBarbeiro} style={{
              width: '100%', backgroundColor: 'transparent', color: '#7bc47b',
              border: '0.5px dashed #2d4a2d', borderRadius: '10px', padding: '11px',
              cursor: 'pointer', fontSize: '13px', fontFamily: 'Arial, sans-serif', marginBottom: '16px',
            }}>+ Adicionar barbeiro</button>
          )}

          {erro && <p style={{ fontSize: '12px', color: '#e24b4a', marginBottom: '8px' }}>{erro}</p>}
          <button onClick={() => { if (validar2()) setEtapa(3); }} style={{
            width: '100%', backgroundColor: '#2d4a2d', color: '#7bc47b',
            border: 'none', borderRadius: '12px', padding: '14px',
            fontSize: '14px', fontWeight: '600', cursor: 'pointer', fontFamily: 'Arial, sans-serif',
          }}>Continuar</button>
        </>
      )}

      {/* ═══════════════ ETAPA 3 ═══════════════ */}
      {etapa === 3 && (
        <>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '24px' }}>
            <span onClick={() => setEtapa(2)} style={{ fontSize: '22px', color: '#8f8f8f', cursor: 'pointer' }}>‹</span>
            <h2 style={{ fontSize: '18px', fontWeight: '700', margin: 0 }}>Serviços oferecidos</h2>
          </div>

          {servicos.map((s, i) => (
            <div key={i} style={{
              backgroundColor: '#181818', border: '0.5px solid #252525',
              borderRadius: '12px', padding: '14px', marginBottom: '10px',
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                <span style={{ fontSize: '12px', color: '#7bc47b', fontWeight: '600' }}>Serviço {i + 1}</span>
                {servicos.length > 1 && (
                  <span onClick={() => removeServico(i)} style={{ fontSize: '20px', color: '#e24b4a', cursor: 'pointer', lineHeight: 1 }}>×</span>
                )}
              </div>

              <div style={{ marginBottom: '8px' }}>
                <label style={labelStyle}>Nome do serviço</label>
                <input type="text" placeholder="Ex: Corte + Barba" value={s.nome}
                  onChange={e => updateServico(i, 'nome', e.target.value)} style={inputStyle} />
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
                <div>
                  <label style={labelStyle}>Preço</label>
                  <input
                    type="text"
                    inputMode="decimal"
                    placeholder="R$ 0,00"
                    value={s.preco}
                    onChange={e => handlePrecoChange(i, e.target.value.replace(/^R\$\s?/, ''))}
                    style={inputStyle}
                  />
                </div>
                <div>
                  <label style={labelStyle}>Duração</label>
                  <select
                    value={s.duracao}
                    onChange={e => updateServico(i, 'duracao', e.target.value)}
                    style={{ ...inputStyle, cursor: 'pointer' }}
                  >
                    {duracoes.map(d => <option key={d} value={d}>{d}</option>)}
                  </select>
                </div>
              </div>
            </div>
          ))}

          {servicos.length < 15 && (
            <button onClick={addServico} style={{
              width: '100%', backgroundColor: 'transparent', color: '#7bc47b',
              border: '0.5px dashed #2d4a2d', borderRadius: '10px', padding: '11px',
              cursor: 'pointer', fontSize: '13px', fontFamily: 'Arial, sans-serif', marginBottom: '16px',
            }}>+ Adicionar serviço</button>
          )}

          {erro && <p style={{ fontSize: '12px', color: '#e24b4a', marginBottom: '8px' }}>{erro}</p>}
          <button onClick={() => { if (validar3()) setEtapa(4); }} style={{
            width: '100%', backgroundColor: '#2d4a2d', color: '#7bc47b',
            border: 'none', borderRadius: '12px', padding: '14px',
            fontSize: '14px', fontWeight: '600', cursor: 'pointer', fontFamily: 'Arial, sans-serif',
          }}>Continuar</button>
        </>
      )}

      {/* ═══════════════ ETAPA 4 ═══════════════ */}
      {etapa === 4 && (
        <>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '24px' }}>
            <span onClick={() => setEtapa(3)} style={{ fontSize: '22px', color: '#8f8f8f', cursor: 'pointer' }}>‹</span>
            <h2 style={{ fontSize: '18px', fontWeight: '700', margin: 0 }}>Acesso ao painel</h2>
          </div>

          <div style={{ marginBottom: '12px' }}>
            <label style={labelStyle}>Email</label>
            <input type="email" placeholder="seu@email.com" value={email}
              onChange={e => setEmail(e.target.value)} style={inputStyle} />
          </div>

          <div style={{ marginBottom: '12px' }}>
            <label style={labelStyle}>Senha</label>
            <div style={{ position: 'relative' }}>
              <input
                type={mostrarSenha ? 'text' : 'password'}
                placeholder="••••••••"
                value={senha}
                onChange={e => setSenha(e.target.value)}
                style={{ ...inputStyle, paddingRight: '60px' }}
              />
              <span onClick={() => setMostrarSenha(!mostrarSenha)} style={{
                position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)',
                fontSize: '11px', color: '#8f8f8f', cursor: 'pointer', userSelect: 'none',
              }}>
                {mostrarSenha ? 'ocultar' : 'mostrar'}
              </span>
            </div>
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={labelStyle}>Confirmar senha</label>
            <input
              type={mostrarSenha ? 'text' : 'password'}
              placeholder="••••••••"
              value={confirmar}
              onChange={e => setConfirmar(e.target.value)}
              style={inputStyle}
            />
          </div>

          <div
            onClick={() => setTermosAceitos(!termosAceitos)}
            style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px', cursor: 'pointer' }}
          >
            <div style={{
              width: '20px', height: '20px', borderRadius: '6px', flexShrink: 0,
              border: `1.5px solid ${termosAceitos ? '#3d6b3d' : '#333'}`,
              backgroundColor: termosAceitos ? '#2d4a2d' : 'transparent',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}>
              {termosAceitos && <span style={{ color: '#7bc47b', fontSize: '13px', fontWeight: '700', lineHeight: 1 }}>✓</span>}
            </div>
            <p style={{ fontSize: '13px', color: '#aeaeae', margin: 0, lineHeight: '1.5' }}>
              Li e aceito os{' '}
              <span
                onClick={e => { e.stopPropagation(); setMostrarTermos(true); }}
                style={{ color: '#7bc47b', textDecoration: 'underline', cursor: 'pointer' }}
              >
                Termos de Uso
              </span>
              {' '}para barbearias parceiras
            </p>
          </div>

          {erro && (
            <div style={{
              backgroundColor: '#1a0a0a', border: '0.5px solid #4a1a1a',
              borderRadius: '8px', padding: '10px 14px', marginBottom: '14px',
            }}>
              <p style={{ fontSize: '12px', color: '#e24b4a', margin: 0 }}>{erro}</p>
            </div>
          )}

          <button onClick={handleCadastro} disabled={carregando} style={{
            width: '100%', backgroundColor: carregando ? '#1a2a1a' : '#2d4a2d',
            color: '#7bc47b', border: 'none', borderRadius: '12px', padding: '14px',
            fontSize: '14px', fontWeight: '600', cursor: carregando ? 'default' : 'pointer',
            fontFamily: 'Arial, sans-serif', marginBottom: '12px',
          }}>
            {carregando ? 'Cadastrando...' : 'Enviar para aprovação'}
          </button>

          <p style={{ textAlign: 'center', fontSize: '11px', color: '#7d7d7d', lineHeight: '1.6' }}>
            Nossa equipe vai revisar e ativar sua barbearia em até 24h.
          </p>
        </>
      )}
    </div>
  );
}

export default CadastroBarbearia;
